export default "816a61d3058d4f39.svg"